import HomeCreatorLanding from "../components/PublicSite/HomeCreatorLanding";
import PublicSiteMeta from "../components/PublicSite/PublicSiteMeta";

export default function HomePage() {
  return <>
    <PublicSiteMeta page="home" />
    <HomeCreatorLanding />
  </>;
}

HomePage.skipInitialLoader = true;
